import { serializable, alias, object, list, primitive } from "serializr";

export class CaseBodyPart {
  @serializable(alias("body_part_id", primitive()))
  bodyPartId?: number;

  @serializable(alias("body_part_name", primitive()))
  bodyPartName?: string;
}
